import type { SVGProps } from 'react';

const SvgHistory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 7.005c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-2v-4c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M12 3.005c-4.96 0-9 4.04-9 9 0 2.05.71 4.03 1.98 5.61l-.68.68c-.29.29-.37.72-.22 1.09s.52.62.92.62h3c.55 0 1-.45 1-1v-3c0-.4-.24-.77-.62-.92-.37-.15-.8-.07-1.09.22l-.9.9a7 7 0 0 1-1.4-4.19c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7c-.55 0-1 .45-1 1s.45 1 1 1c4.96 0 9-4.04 9-9s-4.03-9.01-8.99-9.01"
    />
  </svg>
);
export default SvgHistory;
